<script lang="ts" setup>
    const slug = currentSlug()

    const { data: page, refresh } = await useStatamicEntries().getEntryBySlug<Page>({
        collection: 'pages',
        value: slug,
    })

    useStatamicPreview(refresh)

    useHead({
        bodyAttrs: {
            class: {
                [`page-${slug}`]: true,
                'with-feature-image': computed(() => page.value?.feature_image != null),
            },
        },
        title: () => (page.value?.title != 'Home' ? page.value.title : null),
    })
</script>

<template>
    <div class="page block-gap-b" :class="`page-${slug}`">
        <PageHeader
            :image="page.feature_image"
            :content="page.page_intro ?? ''"
            :faded="slug != 'home'"
        >
            <h1 v-if="page.slug !== 'home'">{{ page.title }}</h1>
        </PageHeader>

        <RoomToText
            v-if="page.room_to_content"
            :content="page.room_to_content"
            :toOffset="page.room_to_to_offset"
        />

        <Blocks v-if="page.blocks" :blocks="page.blocks" />
    </div>
</template>
